"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _useFetch = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useFetch"));
var _getCustomerIdentifier = _interopRequireDefault(require("../utils/getCustomerIdentifier"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useAddresses = () => {
  const {
    REACT_APP_PATH
  } = process.env;
  const customerIdentifier = (0, _getCustomerIdentifier.default)();
  const data = (0, _useFetch.default)({
    authorization: true,
    url: "".concat(REACT_APP_PATH, "/Micado.Shop.Web/Micado.Shop.Web.IO.Api.CustomerApi/GetDetails.api").concat(customerIdentifier ? "?customerIdentifier=".concat(customerIdentifier) : "")
  }, []);
  const {
    addresses
  } = data || [];
  return addresses;
};
var _default = exports.default = useAddresses;